/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { WorkCreateScreenslideDto } from '../models/work-create-screenslide-dto';
import { WorkPaginatedDocumented } from '../models/work-paginated-documented';
import { WorkScreenslide } from '../models/work-screenslide';
import { WorkScreenslideComponent } from '../models/work-screenslide-component';
import { WorkSuccessDto } from '../models/work-success-dto';
import { WorkUpdateScreenslideDto } from '../models/work-update-screenslide-dto';

@Injectable({ providedIn: 'root' })
export class WorkScreenslidesV2Service extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `screenslidesV2ControllerFindAllPaginated()` */
  static readonly ScreenslidesV2ControllerFindAllPaginatedPath = '/v2/screenslides';

  /**
   * Required permissions: screen:read, screen:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `screenslidesV2ControllerFindAllPaginated()` instead.
   *
   * This method doesn't expect any request body.
   */
  screenslidesV2ControllerFindAllPaginated$Response(
    params?: {

    /**
     * Page number to retrieve.If you provide invalid value the default page number will applied
     *         <p>
     *              <b>Example: </b> 1
     *           </p>
     *         <p>
     *              <b>Default Value: </b> 1
     *           </p>
     */
      page?: number;

    /**
     * Number of records per page.
     *       <p>
     *              <b>Example: </b> 20
     *           </p>
     *       <p>
     *              <b>Default Value: </b> 25
     *           </p>
     *       <p>
     *              <b>Max Value: </b> 100
     *           </p>
     *
     *       If provided value is greater than max value, max value will be applied.
     */
      limit?: number;

    /**
     * Filter by active query param.
     *           <p>
     *              <b>Format: </b> filter.active={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.active=$not:$like:John Doe&filter.active=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.active'?: Array<string>;

    /**
     * Filter by screendeviceSlides.screendeviceId query param.
     *           <p>
     *              <b>Format: </b> filter.screendeviceSlides.screendeviceId={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.screendeviceSlides.screendeviceId=$not:$like:John Doe&filter.screendeviceSlides.screendeviceId=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.screendeviceSlides.screendeviceId'?: Array<string>;

    /**
     * Parameter to sort by.
     *       <p>To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting</p>
     *       <p>
     *              <b>Format: </b> fieldName:DIRECTION
     *           </p>
     *       <p>
     *              <b>Example: </b> sortBy=id:DESC&sortBy=createdAt:ASC
     *           </p>
     *       <p>
     *              <b>Default Value: </b> name:ASC
     *           </p>
     *       <h4>Available Fields</h4><ul><li>name</li></ul>
     */
      sortBy?: Array<'name:ASC' | 'name:DESC'>;

    /**
     * Search term to filter result values
     *         <p>
     *              <b>Example: </b> John
     *           </p>
     *         <p>
     *              <b>Default Value: </b> No default value
     *           </p>
     */
      search?: string;

    /**
     * List of fields to search by term to filter result values
     *         <p>
     *              <b>Example: </b> name
     *           </p>
     *         <p>
     *              <b>Default Value: </b> By default all fields mentioned below will be used to search by term
     *           </p>
     *         <h4>Available Fields</h4><ul><li>name</li></ul>
     */
      searchBy?: Array<string>;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkPaginatedDocumented & {
'data'?: Array<WorkScreenslide>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'active'?: (string | Array<string>);
'screendeviceSlides.screendeviceId'?: (string | Array<string>);
};
};
}>> {
    const rb = new RequestBuilder(this.rootUrl, WorkScreenslidesV2Service.ScreenslidesV2ControllerFindAllPaginatedPath, 'get');
    if (params) {
      rb.query('page', params.page, {});
      rb.query('limit', params.limit, {});
      rb.query('filter.active', params['filter.active'], {});
      rb.query('filter.screendeviceSlides.screendeviceId', params['filter.screendeviceSlides.screendeviceId'], {});
      rb.query('sortBy', params.sortBy, {});
      rb.query('search', params.search, {});
      rb.query('searchBy', params.searchBy, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkPaginatedDocumented & {
        'data'?: Array<WorkScreenslide>;
        'meta'?: {
        'select'?: Array<string>;
        'filter'?: {
        'active'?: (string | Array<string>);
        'screendeviceSlides.screendeviceId'?: (string | Array<string>);
        };
        };
        }>;
      })
    );
  }

  /**
   * Required permissions: screen:read, screen:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `screenslidesV2ControllerFindAllPaginated$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  screenslidesV2ControllerFindAllPaginated(
    params?: {

    /**
     * Page number to retrieve.If you provide invalid value the default page number will applied
     *         <p>
     *              <b>Example: </b> 1
     *           </p>
     *         <p>
     *              <b>Default Value: </b> 1
     *           </p>
     */
      page?: number;

    /**
     * Number of records per page.
     *       <p>
     *              <b>Example: </b> 20
     *           </p>
     *       <p>
     *              <b>Default Value: </b> 25
     *           </p>
     *       <p>
     *              <b>Max Value: </b> 100
     *           </p>
     *
     *       If provided value is greater than max value, max value will be applied.
     */
      limit?: number;

    /**
     * Filter by active query param.
     *           <p>
     *              <b>Format: </b> filter.active={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.active=$not:$like:John Doe&filter.active=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.active'?: Array<string>;

    /**
     * Filter by screendeviceSlides.screendeviceId query param.
     *           <p>
     *              <b>Format: </b> filter.screendeviceSlides.screendeviceId={$not}:OPERATION:VALUE
     *           </p>
     *           <p>
     *              <b>Example: </b> filter.screendeviceSlides.screendeviceId=$not:$like:John Doe&filter.screendeviceSlides.screendeviceId=like:John
     *           </p>
     *           <h4>Available Operations</h4><ul><li>$eq</li></ul>
     */
      'filter.screendeviceSlides.screendeviceId'?: Array<string>;

    /**
     * Parameter to sort by.
     *       <p>To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting</p>
     *       <p>
     *              <b>Format: </b> fieldName:DIRECTION
     *           </p>
     *       <p>
     *              <b>Example: </b> sortBy=id:DESC&sortBy=createdAt:ASC
     *           </p>
     *       <p>
     *              <b>Default Value: </b> name:ASC
     *           </p>
     *       <h4>Available Fields</h4><ul><li>name</li></ul>
     */
      sortBy?: Array<'name:ASC' | 'name:DESC'>;

    /**
     * Search term to filter result values
     *         <p>
     *              <b>Example: </b> John
     *           </p>
     *         <p>
     *              <b>Default Value: </b> No default value
     *           </p>
     */
      search?: string;

    /**
     * List of fields to search by term to filter result values
     *         <p>
     *              <b>Example: </b> name
     *           </p>
     *         <p>
     *              <b>Default Value: </b> By default all fields mentioned below will be used to search by term
     *           </p>
     *         <h4>Available Fields</h4><ul><li>name</li></ul>
     */
      searchBy?: Array<string>;
    },
    context?: HttpContext
  ): Observable<WorkPaginatedDocumented & {
'data'?: Array<WorkScreenslide>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'active'?: (string | Array<string>);
'screendeviceSlides.screendeviceId'?: (string | Array<string>);
};
};
}> {
    return this.screenslidesV2ControllerFindAllPaginated$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkPaginatedDocumented & {
'data'?: Array<WorkScreenslide>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'active'?: (string | Array<string>);
'screendeviceSlides.screendeviceId'?: (string | Array<string>);
};
};
}>): WorkPaginatedDocumented & {
'data'?: Array<WorkScreenslide>;
'meta'?: {
'select'?: Array<string>;
'filter'?: {
'active'?: (string | Array<string>);
'screendeviceSlides.screendeviceId'?: (string | Array<string>);
};
};
} => r.body)
    );
  }

  /** Path part for operation `screenslidesV2ControllerCreate()` */
  static readonly ScreenslidesV2ControllerCreatePath = '/v2/screenslides';

  /**
   * Required permissions: screen:create, screen:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `screenslidesV2ControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  screenslidesV2ControllerCreate$Response(
    params: {
      body: WorkCreateScreenslideDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkScreenslide>> {
    const rb = new RequestBuilder(this.rootUrl, WorkScreenslidesV2Service.ScreenslidesV2ControllerCreatePath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkScreenslide>;
      })
    );
  }

  /**
   * Required permissions: screen:create, screen:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `screenslidesV2ControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  screenslidesV2ControllerCreate(
    params: {
      body: WorkCreateScreenslideDto
    },
    context?: HttpContext
  ): Observable<WorkScreenslide> {
    return this.screenslidesV2ControllerCreate$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkScreenslide>): WorkScreenslide => r.body)
    );
  }

  /** Path part for operation `screenslidesV2ControllerFindById()` */
  static readonly ScreenslidesV2ControllerFindByIdPath = '/v2/screenslides/{id}';

  /**
   * Required permissions: screen:read, screen:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `screenslidesV2ControllerFindById()` instead.
   *
   * This method doesn't expect any request body.
   */
  screenslidesV2ControllerFindById$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkScreenslide>> {
    const rb = new RequestBuilder(this.rootUrl, WorkScreenslidesV2Service.ScreenslidesV2ControllerFindByIdPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkScreenslide>;
      })
    );
  }

  /**
   * Required permissions: screen:read, screen:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `screenslidesV2ControllerFindById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  screenslidesV2ControllerFindById(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<WorkScreenslide> {
    return this.screenslidesV2ControllerFindById$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkScreenslide>): WorkScreenslide => r.body)
    );
  }

  /** Path part for operation `screenslidesV2ControllerDelete()` */
  static readonly ScreenslidesV2ControllerDeletePath = '/v2/screenslides/{id}';

  /**
   * Required permissions: screen:delete, screen:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `screenslidesV2ControllerDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  screenslidesV2ControllerDelete$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<boolean>> {
    const rb = new RequestBuilder(this.rootUrl, WorkScreenslidesV2Service.ScreenslidesV2ControllerDeletePath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: String((r as HttpResponse<any>).body) === 'true' }) as StrictHttpResponse<boolean>;
      })
    );
  }

  /**
   * Required permissions: screen:delete, screen:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `screenslidesV2ControllerDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  screenslidesV2ControllerDelete(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<boolean> {
    return this.screenslidesV2ControllerDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

  /** Path part for operation `screenslidesV2ControllerUpdate()` */
  static readonly ScreenslidesV2ControllerUpdatePath = '/v2/screenslides/{id}';

  /**
   * Required permissions: screen:update, screen:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `screenslidesV2ControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  screenslidesV2ControllerUpdate$Response(
    params: {
      id: number;
      body: WorkUpdateScreenslideDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkScreenslide>> {
    const rb = new RequestBuilder(this.rootUrl, WorkScreenslidesV2Service.ScreenslidesV2ControllerUpdatePath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkScreenslide>;
      })
    );
  }

  /**
   * Required permissions: screen:update, screen:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `screenslidesV2ControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  screenslidesV2ControllerUpdate(
    params: {
      id: number;
      body: WorkUpdateScreenslideDto
    },
    context?: HttpContext
  ): Observable<WorkScreenslide> {
    return this.screenslidesV2ControllerUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkScreenslide>): WorkScreenslide => r.body)
    );
  }

  /** Path part for operation `screenslidesV2ControllerFindComponentsForSlide()` */
  static readonly ScreenslidesV2ControllerFindComponentsForSlidePath = '/v2/screenslides/{id}/components';

  /**
   * Required permissions: screen:read, screen:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `screenslidesV2ControllerFindComponentsForSlide()` instead.
   *
   * This method doesn't expect any request body.
   */
  screenslidesV2ControllerFindComponentsForSlide$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkScreenslideComponent>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkScreenslidesV2Service.ScreenslidesV2ControllerFindComponentsForSlidePath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkScreenslideComponent>>;
      })
    );
  }

  /**
   * Required permissions: screen:read, screen:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `screenslidesV2ControllerFindComponentsForSlide$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  screenslidesV2ControllerFindComponentsForSlide(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<Array<WorkScreenslideComponent>> {
    return this.screenslidesV2ControllerFindComponentsForSlide$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkScreenslideComponent>>): Array<WorkScreenslideComponent> => r.body)
    );
  }

  /** Path part for operation `screenslidesV2ControllerAddComponentToSlide()` */
  static readonly ScreenslidesV2ControllerAddComponentToSlidePath = '/v2/screenslides/{id}/components/{componentId}/{position}';

  /**
   * Required permissions: screen:update, screen:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `screenslidesV2ControllerAddComponentToSlide()` instead.
   *
   * This method doesn't expect any request body.
   */
  screenslidesV2ControllerAddComponentToSlide$Response(
    params: {
      id: number;
      componentId: number;
      position: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkSuccessDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkScreenslidesV2Service.ScreenslidesV2ControllerAddComponentToSlidePath, 'post');
    if (params) {
      rb.path('id', params.id, {});
      rb.path('componentId', params.componentId, {});
      rb.path('position', params.position, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkSuccessDto>;
      })
    );
  }

  /**
   * Required permissions: screen:update, screen:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `screenslidesV2ControllerAddComponentToSlide$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  screenslidesV2ControllerAddComponentToSlide(
    params: {
      id: number;
      componentId: number;
      position: number;
    },
    context?: HttpContext
  ): Observable<WorkSuccessDto> {
    return this.screenslidesV2ControllerAddComponentToSlide$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkSuccessDto>): WorkSuccessDto => r.body)
    );
  }

  /** Path part for operation `screenslidesV2ControllerRemoveComponentFromSlide()` */
  static readonly ScreenslidesV2ControllerRemoveComponentFromSlidePath = '/v2/screenslides/{id}/components/{componentId}';

  /**
   * Required permissions: screen:delete, screen:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `screenslidesV2ControllerRemoveComponentFromSlide()` instead.
   *
   * This method doesn't expect any request body.
   */
  screenslidesV2ControllerRemoveComponentFromSlide$Response(
    params: {
      id: number;
      componentId: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkSuccessDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkScreenslidesV2Service.ScreenslidesV2ControllerRemoveComponentFromSlidePath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
      rb.path('componentId', params.componentId, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkSuccessDto>;
      })
    );
  }

  /**
   * Required permissions: screen:delete, screen:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `screenslidesV2ControllerRemoveComponentFromSlide$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  screenslidesV2ControllerRemoveComponentFromSlide(
    params: {
      id: number;
      componentId: number;
    },
    context?: HttpContext
  ): Observable<WorkSuccessDto> {
    return this.screenslidesV2ControllerRemoveComponentFromSlide$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkSuccessDto>): WorkSuccessDto => r.body)
    );
  }

  /** Path part for operation `screenslidesV2ControllerAddDocumentToSlide()` */
  static readonly ScreenslidesV2ControllerAddDocumentToSlidePath = '/v2/screenslides/{id}/documents/{documentId}';

  /**
   * Required permissions: screen:update, screen:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `screenslidesV2ControllerAddDocumentToSlide()` instead.
   *
   * This method doesn't expect any request body.
   */
  screenslidesV2ControllerAddDocumentToSlide$Response(
    params: {
      id: number;
      documentId: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkSuccessDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkScreenslidesV2Service.ScreenslidesV2ControllerAddDocumentToSlidePath, 'post');
    if (params) {
      rb.path('id', params.id, {});
      rb.path('documentId', params.documentId, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkSuccessDto>;
      })
    );
  }

  /**
   * Required permissions: screen:update, screen:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `screenslidesV2ControllerAddDocumentToSlide$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  screenslidesV2ControllerAddDocumentToSlide(
    params: {
      id: number;
      documentId: number;
    },
    context?: HttpContext
  ): Observable<WorkSuccessDto> {
    return this.screenslidesV2ControllerAddDocumentToSlide$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkSuccessDto>): WorkSuccessDto => r.body)
    );
  }

  /** Path part for operation `screenslidesV2ControllerRemoveDocumentFromSlide()` */
  static readonly ScreenslidesV2ControllerRemoveDocumentFromSlidePath = '/v2/screenslides/{id}/documents/{documentId}';

  /**
   * Required permissions: screen:delete, screen:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `screenslidesV2ControllerRemoveDocumentFromSlide()` instead.
   *
   * This method doesn't expect any request body.
   */
  screenslidesV2ControllerRemoveDocumentFromSlide$Response(
    params: {
      id: number;
      documentId: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkSuccessDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkScreenslidesV2Service.ScreenslidesV2ControllerRemoveDocumentFromSlidePath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
      rb.path('documentId', params.documentId, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkSuccessDto>;
      })
    );
  }

  /**
   * Required permissions: screen:delete, screen:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `screenslidesV2ControllerRemoveDocumentFromSlide$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  screenslidesV2ControllerRemoveDocumentFromSlide(
    params: {
      id: number;
      documentId: number;
    },
    context?: HttpContext
  ): Observable<WorkSuccessDto> {
    return this.screenslidesV2ControllerRemoveDocumentFromSlide$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkSuccessDto>): WorkSuccessDto => r.body)
    );
  }

  /** Path part for operation `screenslidesV2ControllerFindPublicDataById()` */
  static readonly ScreenslidesV2ControllerFindPublicDataByIdPath = '/v2/screenslides/data/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `screenslidesV2ControllerFindPublicDataById()` instead.
   *
   * This method doesn't expect any request body.
   */
  screenslidesV2ControllerFindPublicDataById$Response(
    params: {
      id: number;

    /**
     * This request requires a valid API key.
     */
      'x-api-key'?: string;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkScreenslide>> {
    const rb = new RequestBuilder(this.rootUrl, WorkScreenslidesV2Service.ScreenslidesV2ControllerFindPublicDataByIdPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
      rb.header('x-api-key', params['x-api-key'], {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkScreenslide>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `screenslidesV2ControllerFindPublicDataById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  screenslidesV2ControllerFindPublicDataById(
    params: {
      id: number;

    /**
     * This request requires a valid API key.
     */
      'x-api-key'?: string;
    },
    context?: HttpContext
  ): Observable<WorkScreenslide> {
    return this.screenslidesV2ControllerFindPublicDataById$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkScreenslide>): WorkScreenslide => r.body)
    );
  }

}
